import type React from 'react';
import { ProjectMeasuringPointList } from '../components/ProjectMeasuringPointList';
import SkeletonLoader from '../../../skeletonLoader/SkeletonLoader';
import type { MeasuringPointWithProject } from '../types';
import type { UseOrderAndPaginationControlReturn } from '../../../table/hooks';
import { OverviewSectionCard } from './OverviewSectionCard';

interface OverviewStandaloneSectionProps {
    measuringPoints: MeasuringPointWithProject[];
    loading?: boolean;
    orderAndPaginationControl: UseOrderAndPaginationControlReturn;
}

export function OverviewStandaloneSection({
    measuringPoints,
    loading = false,
    orderAndPaginationControl,
}: OverviewStandaloneSectionProps): React.ReactElement {
    return (
        <OverviewSectionCard title={gettext('OVERVIEW_PAGE_TAB_STANDALONE_SUBTITLE')}>
            {loading ? (
                <div className="p-4">
                    <SkeletonLoader count={3} className="h-4" />
                </div>
            ) : (
                <ProjectMeasuringPointList
                    measuringPoints={measuringPoints}
                    orderAndPaginationControl={orderAndPaginationControl}
                />
            )}
        </OverviewSectionCard>
    );
}
